module.exports = __webpack_public_path__ + "media/images/lb/621-b57498291bab60ab0b627f24c4058fcc.svg";